<template>
  <div>

    <div class="breadcrumb">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">应用列表</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="top-btns">
      <el-button class="create-btn" size="small" @click="createDialog.visible = true">创建应用</el-button>
    </div>

    <div class="user-apps" v-loading="userAppsLoading" v-if="userApps.length !== 0">
      <template v-for="userApp of userApps">
        <user-app
          :appInfo="userApp"
          @onEdit="onUserAppEditClicked(userApp)"
          @delete="onUserAppDelete(userApp)"
        ></user-app>
      </template>
    </div>
    <div class="user-app user-apps-n" v-else>
      <el-card>
        <p class="user-app-n-text">暂无应用</p>
      </el-card>
    </div>

    <el-dialog
      title="创建应用"
      :visible.sync="createDialog.visible"
      width="50%"
      class="dialog-create-app">
      <div class="dialog-app-name">
        <span>应用名称: </span>
        <el-input
          class="input-app-name"
          placeholder="请输入应用名称"
          v-model.trim="createDialog.appName"
          clearable></el-input>
      </div>
      <div style="margin-top: 20px">
        <span>应用描述: </span>
        <el-input
          type="textarea"
          :rows="5"
          resize="none"
          placeholder="请输入应用描述"
          maxlength="200"
          v-model.trim="createDialog.appDescription">
        </el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          size="small"
          class="create-app-sure-btn"
          :disabled="!createDialog.appName"
          :loading="createDialog.saving"
          @click="onCreateAppClicked">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="修改参数"
      :visible.sync="editDialog.visible"
      width="50%"
      class="dialog-edit-app">
      <div class="dialog-edit-app-control">
        <div class="p-text">
          <el-tooltip
            effect="dark"
            content="拍摄脸部图片后与身份证相片匹配最低值(建议最低值为50)"
            placement="bottom-start"
          ><p>证件匹配度</p>
          </el-tooltip>
        </div>
        <div class="p-slider">
          <el-slider
            v-model="editDialog.compare_min"
            show-input
            :show-input-controls="false">
          </el-slider>
        </div>
      </div>

      <div class="dialog-edit-app-control">
        <div class="p-text">
          <el-tooltip
            effect="dark"
            content="拍摄脸部图片后搜索匹配最低值(建议最低值为75)"
            placement="bottom-start"
          ><p>识别匹配度</p>
          </el-tooltip>
        </div>
        <div class="p-slider">
          <el-slider
            v-model="editDialog.search_min"
            show-input
            :show-input-controls="false">
          </el-slider>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button
          size="small"
          class="edit-app-sure-btn"
          :loading="editDialog.saving"
          @click="onEditAppSaveClicked">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
  import UserApp from "@/components/UserApp"
  import EventBus from "@/EventBus"
  import axios from "axios"

  export default {
    name: 'UserApps',
    components: {
      UserApp,
    },
    data() {
      return {
        userAppsLoading: true,
        userApps: [],
        createDialog: {
          visible: false,
          appName: "",
          appDescription: "",
        },
        editDialog: {
          visible: false,
          saving: false,
          app_key: 0,
          search_min: 0,
          compare_min: 0,
        }
      }
    },
    created() {
      this.loadUserApps();
    },
    methods: {
      loadUserApps() {
        axios.get("/apps/")
          .then(resp => {
            this.userApps = resp.data.apps;
          }).catch(err => this.$message.error("加载应用列表失败"))
          .finally(() => this.userAppsLoading = false)
      },
      onCreateAppClicked() {
        axios.post("/apps/", {
          app_name: this.createDialog.appName,
          app_description: this.createDialog.appDescription,
        }).then(resp => {
          this.userApps.push(resp.data.app);
          this.createDialog.visible = false;
          this.createDialog.appName = "";
          this.createDialog.appDescription = "";
          this.$notify.success("已创建");
        }).catch(err => this.$message.error("创建应用失败"));
      },
      onUserAppEditClicked(userApp) {
        this.editDialog.visible = true;
        this.editDialog.app_key = userApp.app_key;
        this.editDialog.search_min = userApp.search_min;
        this.editDialog.compare_min = userApp.compare_min;
      },
      onEditAppSaveClicked() {
        this.editDialog.saving = true;
        axios.patch(`/apps/${this.editDialog.app_key}/`, {
          search_min: this.editDialog.search_min,
          compare_min: this.editDialog.compare_min,
        }).then(resp => {
          let app = this.userApps.find(app => app.app_key === this.editDialog.app_key);
          app.search_min = this.editDialog.search_min;
          app.compare_min = this.editDialog.compare_min;
          this.editDialog.visible = false;
          this.$notify.success("已更新");
        }).catch(err => this.$message.error("更新应用参数失败"))
          .finally(() => this.editDialog.saving = false)
      },
      onUserAppDelete(userApp) {
        axios.delete(`/apps/${userApp.app_key}/`)
          .then(resp => {
            let i = this.userApps.findIndex(app => app.app_key === userApp.app_key);
            if (i === -1) this.$message.error("删除应用失败");
            this.userApps.splice(i, 1);
            EventBus.$emit("user_app_deleted");
            this.$notify.success("已删除");
          })
          .catch(err => this.$message.error("删除应用失败"))
      }
    }
  }
</script>

<style lang="stylus" scoped>
  @import "../share/styles/colors.styl"
  @import "../share/styles/bread_crumb.styl"
  @import "../share/styles/user_app.styl"

  .user-apps
    height 100%

  .top-btns
    margin-left 1em
    margin-right 1em
    margin-bottom 1em
    text-align right

    .create-btn
      baseBtn()

  .create-app-sure-btn
  .edit-app-sure-btn
    baseBtn()

  .dialog-app-name
    & span
      display inline-block
      width 20%
    & .input-app-name
      display inline-block
      width 50%

  .dialog-edit-app-control
    display flex
    vertical-align middle
    & .p-text
      margin auto
      display inline-block
      width 20%
    & .p-slider
      display inline-block
      width 80%

  .dialog-edit-app-control + .dialog-edit-app-control
    margin-top 1.2em

  >>> .el-slider__input
    width 80px

  >>> .el-slider__runway.show-input
    margin-right 100px

  @media screen and (max-width: 600px)
    .dialog-create-app
    .dialog-edit-app
      & >>> .el-dialog
        width 95% !important

    .dialog-edit-app-control
      display block
      & > div
        width 100% !important

</style>



// WEBPACK FOOTER //
// src/components/UserApps.vue